export const isNumericOnly = (value) => {
  if (/^[0-9]+$/.test(value) || value === "") {
    return true;
  } else {
    return false;
  }
};


export const isFractionalNumOnly = (value) => {
  if (/^(0|[1-9]\d*)(\.\d+)?$/.test(value) || value === "") {
    return true;
  } else {
    return false;
  }
};